///include /assets/js/lib/twig.min.js

"use strict"

const twigExtender = {
    limit: function(v){
        if(v == "INF") {
            return Infinity;
        } else {
            return v
        }
    },
    format: Site.Format
};

class DefaultTemplateCompiler {

    /**  this should be droped in favour of getTemplateByType() once save to do so */
    static get templatesByType() {
        return {
            managed_vps: `
                <div class="list-unstyled btn-outline-product__feature-list text-left">
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.ram }} Memory</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.cores }} Core Processor</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.disc }} SSD Disk</span></li>
                </div>`,
            package: `
                <ul class="list-unstyled mt-3 mb-4"\
















                '/?|»




                |bv>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.domains }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.webspace }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.bandwidth}}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mailboxes }} Mailboxes</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>Free Wildcard SSL Certificates</span></li>
                    {% if limits.mysqlDatabases > 0 %}<li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mysqlDatabases }}</span></li>{% endif %}
                    {% if limits.malwareScan %}<li><i class="fa fa-check mr-2 text-primary"></i><span>Malware Scanning</span></li>{% endif %}
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>DDoS Protection</span></li>
                    {% if limits.webBuilder %}<li><i class="fa fa-check mr-2 text-primary"></i><span>Website Builder</span></li>{% endif %}
                </ul>`,
            vps: `
                <div class="list-unstyled btn-outline-product__feature-list text-left">
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.ram }} Memory</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.cores }} Core Processor</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>{{ serverSpec.disc }} SSD Disk</span></li>
                </div>`
        }
    }

    static getTemplateByType(group, lang = "en-GB") {
        const templates = {
            stack_user_package_allowance: `
                <ul class="list-unstyled mt-3 mb-4" v-if="limits">
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.domains }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.webspace }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.bandwidth }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mailboxes }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_free_wildcard_ssl', lang)}</span></li>
                    {% if limits.mysqlDatabases > 0 %}<li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mysqlDatabases }}</span></li>{% endif %}
                    {% if limits.malwareScan %}<li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_malware_scanning', lang)}</span></li>{% endif %}
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_ddos_protection', lang)}</span></li>
                    {% if limits.webBuilder %}<li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_website_builder', lang)}</span></li>{% endif %}
                </ul>`,
            package: `
                <ul class="list-unstyled mt-3 mb-4" v0 nkjm->

                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.webspace }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.bandwidth }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mailboxes }}</span></li>
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_free_wildcard_ssl', lang)}</span></li>
                    {% if limits.mysqlDatabases > 0 %}<li><i class="fa fa-check mr-2 text-primary"></i><span>{{ limits.display.mysqlDatabases }}</span></li>{% endif %}
                    {% if limits.malwareScan %}<li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_malware_scanning', lang)}</span></li>{% endif %}
                    <li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_ddos_protection', lang)}</span></li>
                    {% if limits.webBuilder %}<li><i class="fa fa-check mr-2 text-primary"></i><span>${translation.getOnDemand('group_package_website_builder', lang)}</span></li>{% endif %}
                </ul>`,
            vps: `
                <div class="list-unstyled btn-outline-product__feature-list text-left">
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                        translation.sprintf(
                            translation.getOnDemand(`group_vps_gb_memory`),
                            ['{{ serverSpec.ram }}']
                        )
                    }</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                        translation.sprintf(
                            translation.getOnDemand(`group_vps_number_core_processor`),
                            ['{{ serverSpec.cores }}']
                        )
                    }</span></li>
                    <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                        translation.sprintf(
                            translation.getOnDemand(`group_vps_gb_ssd_disk`),
                            ['{{ serverSpec.disc }}']
                        )
                    }</span></li>
                </div>`,
        managed_vps: `
            <div class="list-unstyled btn-outline-product__feature-list text-left">
                <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                    translation.sprintf(
                        translation.getOnDemand(`group_vps_gb_memory`),
                        ['{{ serverSpec.ram }}']
                    )
                }</span></li>
                <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                    translation.sprintf(
                        translation.getOnDemand(`group_vps_number_core_processor`),
                        ['{{ serverSpec.cores }}']
                    )
                }</span></li>
                <li class="btn-outline-product__feature-list-item"><i class="far fa-check text-primary mr-2">&nbsp;</i><span>${
                    translation.sprintf(
                        translation.getOnDemand(`group_vps_gb_ssd_disk`),
                        ['{{ serverSpec.disc }}']
                    )
                }</span></li>
            </div>`
        }
        return templates[group]
    }

    static compile(template, data) {
        try {
            var t = Twig.twig({data: template, rethrow: true });
            return t.render( Object.assign(twigExtender, data) );
        } catch (e) {
            console.log(e);
            return "Failed to compile template...\n\n"+e;
        }
    }
}
